<template>
    <google-analytics-inertia/>
    <HoneybadgerErrorTracking/>
    <div
        class="container mx-auto w-full py-24 text-[18px] print:max-w-full print:text-[14px]"
    >
        <div class="mb-12">
            <img
                src="/assets/art/logos/emtprep_logo_color@3x.png"
                class="h-20 w-auto print:h-12"
            />
        </div>

        <div class="w-full">
            <table class="w-full">
                <tbody>
                <tr class="h-12">
                    <td class="text-left">
                        <div
                            class="text-[30px] font-semibold print:text-[20px]"
                        >
                            EMTprep.com
                        </div>
                        <div
                            class="text-[18px] font-semibold print:text-[12px]"
                        >
                            by Classward
                        </div>
                        <div class="mt-4">
                            <p>
                                33848 SE Eastgate Cir. <br/>
                                Corvallis, OR 97333 <br/>
                                <br/>
                                INFO@EMTPREP.COM
                            </p>
                        </div>
                    </td>
                    <td class="text-right">
                        <div class="flex justify-end">
                            <slot name="meta"/>
                        </div>
                    </td>
                </tr>
                </tbody>
            </table>
        </div>

        <slot/>
    </div>
</template>
<script>
import GoogleAnalyticsInertia from "@/Components/GoogleAnalyticsInertia.vue";
import HoneybadgerErrorTracking from "@/Components/HoneybadgerErrorTracking.vue";

export default {
    name: "ReceiptLayout",
    components: {HoneybadgerErrorTracking, GoogleAnalyticsInertia},
    props: {
        headerTitle: {
            type: String,
            default: "",
        },
        closeRedirectRoute: {
            type: String,
            default: null,
        },
    },
};
</script>
